<template>
  <div class="login-reg">
    <h1 title="233网校推广联盟"></h1>
    <div class="box">
      <div class="go-link">
        <template v-if="$route.name === 'login'">
          还没账号？<router-link to="/reg">立即注册</router-link>
        </template>
        <template v-else>
          已有账号？<router-link to="/login">立即登录</router-link>
        </template>
      </div>
      <div class="main">
        <img src="../../../assets/img/login-introduce-text1.png" v-if="$route.name === 'login'">
        <img src="../../../assets/img/login-introduce-text2.png" v-else>
        <slot />
      </div>
    </div>
    <foot />
  </div>
</template>

<script>
import foot from "./cell/foot"
export default {
  name: "LoginReg",
  components: {
    foot
  }
}
</script>

<style lang="scss" scoped>
.login-reg{
  width: 100%;
  height: 100%;
  overflow: auto;
  background: url("../../../assets/img/login-bg.jpg") no-repeat;
  background-size: 100%;
  h1{
    width: 300px;
    height: 30px;
    background: url("../../../assets/img/login-icon.png") no-repeat 0 0;
    background-size: 600px 160px;
    margin: 30px 0 0 30px;
  }
  .box{
    width: 1000px;
    margin: 28px auto 0;
    .go-link{
      font-size: 16px;
      color: #999;
      text-align: right;
      a{
        color: #EF8925;
      }
    }
    .main{
      height: 620px;
      background: url("../../../assets/img/login-introduce-bg.jpg") no-repeat left top;
      box-shadow:0px 6px 18px 0px rgba(249,243,238,1);
      border-radius:6px;
      background-size: 340px 100%;
      padding-left: 340px;
      position: relative;
      margin-top: 16px;
      img{
        position: absolute;
        top: 160px;
        left: 30px;
      }
    }
  }
}
</style>